import type { TFunction } from 'i18next';

/** Maps WMO codes to UI icons (compatible with OpenWeatherMap icon assets). */
export function wmoCodeToUiIcon(code: number): string {
  if (code === 0) return '01d';
  if (code === 1) return '02d';
  if (code === 2) return '03d';
  if (code === 3) return '04d';
  if (code === 45 || code === 48) return '50d';
  if (code === 51 || code === 53 || code === 55) return '09d';
  if (code === 56 || code === 57) return '13d';
  if (code === 61 || code === 63 || code === 65) return '10d';
  if (code === 66 || code === 67) return '13d';
  if (code === 71 || code === 73 || code === 75 || code === 77) return '13d';
  if (code === 80) return '09d';
  if (code === 81) return '10d';
  if (code === 82) return '11d';
  if (code === 85 || code === 86) return '13d';
  if (code === 95 || code === 96 || code === 99) return '11d';
  return '02d';
}

export function describeWmoWeatherCode(code: number, t: TFunction): string {
  switch (code) {
    case 0:
      return t('weather.wmo.0');
    case 1:
      return t('weather.wmo.1');
    case 2:
      return t('weather.wmo.2');
    case 3:
      return t('weather.wmo.3');
    case 45:
      return t('weather.wmo.45');
    case 48:
      return t('weather.wmo.48');
    case 51:
      return t('weather.wmo.51');
    case 53:
      return t('weather.wmo.53');
    case 55:
      return t('weather.wmo.55');
    case 56:
      return t('weather.wmo.56');
    case 57:
      return t('weather.wmo.57');
    case 61:
      return t('weather.wmo.61');
    case 63:
      return t('weather.wmo.63');
    case 65:
      return t('weather.wmo.65');
    case 66:
      return t('weather.wmo.66');
    case 67:
      return t('weather.wmo.67');
    case 71:
      return t('weather.wmo.71');
    case 73:
      return t('weather.wmo.73');
    case 75:
      return t('weather.wmo.75');
    case 77:
      return t('weather.wmo.77');
    case 80:
      return t('weather.wmo.80');
    case 81:
      return t('weather.wmo.81');
    case 82:
      return t('weather.wmo.82');
    case 85:
      return t('weather.wmo.85');
    case 86:
      return t('weather.wmo.86');
    case 95:
      return t('weather.wmo.95');
    case 96:
      return t('weather.wmo.96');
    case 99:
      return t('weather.wmo.99');
    default:
      return t('weather.wmo.unknown');
  }
}
